import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, Store, Gift, Megaphone, Star, Settings, LogOut, Tag, Ticket, Users, QrCode, Map, Image, Menu, X, UserPlus, TrendingUp } from 'lucide-react';
import StoresManagement from '../components/admin/StoresManagement';
import BenefitsManagement from '../components/admin/BenefitsManagement';
import CampaignsManagement from '../components/admin/CampaignsManagement';
import FeaturedManagement from '../components/admin/FeaturedManagement';
import Statistics from '../components/admin/Statistics';
import QRSettings from '../components/admin/QRSettings';
import BrandsManagement from '../components/admin/BrandsManagement';
import PromotionsManagement from '../components/admin/PromotionsManagement';
import AdsManagement from '../components/admin/AdsManagement';
import SubscribersManagement from '../components/admin/SubscribersManagement';
import QrRedemptionsManagement from '../components/admin/QrRedemptionsManagement';
import OutletMapManagement from '../components/admin/OutletMapManagement';
import FeaturedStoresManagement from '../components/admin/FeaturedStoresManagement';
import PromotersManagement from '../components/admin/PromotersManagement';
import PromoterMetrics from '../components/admin/PromoterMetrics';
import { authService } from '../services/auth';
import Footer from '../components/Footer';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('statistics');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const tabs = [
    { id: 'statistics', label: 'Estadísticas', icon: BarChart3 },
    // { id: 'brands', label: 'Marcas', icon: Tag },
    // { id: 'promotions', label: 'Promociones', icon: Ticket },
    { id: 'outlet-map', label: 'Mapa del Outlet', icon: Map },
    { id: 'subscribers', label: 'Suscriptores', icon: Users },
    { id: 'qr-redemptions', label: 'Canjes QR', icon: QrCode },
    { id: 'promoters', label: 'Promotores', icon: UserPlus },
    { id: 'promoter-metrics', label: 'Métricas Promotores', icon: TrendingUp },
    // { id: 'ads', label: 'Anuncios', icon: Image },
    { id: 'featured-stores', label: 'Tiendas Destacadas', icon: Star },
    { id: 'stores', label: 'Tiendas', icon: Store },
    { id: 'benefits', label: 'Beneficios', icon: Gift },
    // { id: 'campaigns', label: 'Campañas', icon: Megaphone },
    { id: 'qr', label: 'QR Settings', icon: Settings },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'statistics':
        return <Statistics />;
      case 'brands':
        return <BrandsManagement />;
      case 'promotions':
        return <PromotionsManagement />;
      case 'outlet-map':
        return <OutletMapManagement />;
      case 'subscribers':
        return <SubscribersManagement />;
      case 'qr-redemptions':
        return <QrRedemptionsManagement />;
      case 'promoters':
        return <PromotersManagement />;
      case 'promoter-metrics':
        return <PromoterMetrics />;
      case 'ads':
        return <AdsManagement />;
      case 'featured-stores':
        return <FeaturedStoresManagement />;
      case 'stores':
        return <StoresManagement />;
      case 'benefits':
        return <BenefitsManagement />;
      case 'featured':
        return <FeaturedManagement />;
      case 'campaigns':
        return <CampaignsManagement />;
      case 'qr':
        return <QRSettings />;
      default:
        return <Statistics />;
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <div className="px-6 py-6 border-b border-white/10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-white transition-all hover:scale-105 active:scale-95"
            >
              {sidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
            <div>
              <h1 className="text-2xl font-bold text-white mb-1">Panel de Administración</h1>
              <p className="text-[#A2A2A2]">Gestiona tu plataforma</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-white transition-all hover:scale-105 active:scale-95"
          >
            <LogOut className="w-4 h-4" />
            <span className="text-sm font-medium">Salir</span>
          </button>
        </div>
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar - Se puede ocultar */}
        <div className={`${
          sidebarOpen ? 'w-48 sm:w-56 md:w-64' : 'w-0'
        } border-r border-white/10 bg-black/50 overflow-y-auto flex-shrink-0 transition-all duration-300 ease-in-out ${
          sidebarOpen ? '' : 'hidden'
        }`}>
          <div className="p-2 sm:p-3 md:p-4 space-y-1 sm:space-y-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => {
                    setActiveTab(tab.id);
                    setSidebarOpen(false);
                  }}
                  className={`w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 md:px-4 py-2 sm:py-2.5 md:py-3 rounded-xl transition-all ${
                    isActive
                      ? 'bg-white text-black'
                      : 'text-[#A2A2A2] hover:text-white hover:bg-white/10'
                  }`}
                >
                  <Icon className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 ${isActive ? 'text-black' : ''}`} />
                  <span className="font-medium text-xs sm:text-sm md:text-base truncate">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Content Area - Ocupa todo el ancho cuando el sidebar está oculto */}
        <div className="flex-1 overflow-y-auto min-w-0 w-full flex flex-col">
          <div className="flex-1">
            {renderContent()}
          </div>
          <Footer className="mt-auto" />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;

